import {
  SET_STEP_ONE_DATA,
  SET_STEP_TWO_DATA,
  SET_USER_ID,
  RESET_USER_CREATE_DATA,
} from './UserCreate.constant';
import { UserCreateActionsTypes } from './UserCreate.type';
import { IUserCreateForm } from 'entities/view/userCreate';
import { IStepOneForm } from 'store/UserUpdate/UserUpdate.type';

export const setStepOneData = (payload: IStepOneForm): UserCreateActionsTypes => ({
  type: SET_STEP_ONE_DATA,
  payload,
});

export const setStepTwoData = (
  payload: IUserCreateForm,
): UserCreateActionsTypes => ({
  type: SET_STEP_TWO_DATA,
  payload,
});

export const setUserId = (payload: number): UserCreateActionsTypes => ({
  type: SET_USER_ID,
  payload,
});

export const resetUserCreateData = (): UserCreateActionsTypes => ({
  type: RESET_USER_CREATE_DATA,
});
